import { Box, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Typography, useTheme } from '@mui/material'
import React from 'react'
import { Icons, formatDate } from '../../utils/utilities'
import { useNavigate } from 'react-router-dom'
import TableHeader from '../common/TableHeader'
import CustomChip from '../common/CustomChip'


const columns = [
    { label: "Material Name", align: "left", minWidth: "200px", padding: "5px 20px 5px 20px" },
    { label: "Subject-Code", align: "left", minWidth: "200px" },
    { label: "Created on", align: "left", minWidth: "180px" },
    { label: "Last updated", align: "left", minWidth: "180px" },
    { label: "Downloads", align: "center", minWidth: "150px", padding: "5px 20px 5px 20px" },
    { label: "Document count", align: "center", minWidth: "150px", padding: "5px 20px 5px 20px" },
]

const FacultyMaterialsList = ( { filteredMaterials, docsCount, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } ) => {

    const { palette, table, border } = useTheme()
    const navigate = useNavigate()

    return (
        <Box border={border[1]} flexGrow={1} marginTop="10px" borderRadius="5px" minHeight="400px" overflow="auto" display="flex" flexDirection="column" justifyContent="space-between" >
            <TableContainer className="custom-scrollbar" sx={{ borderRadius: "0 0 5px 5px", overflow: "auto" }}>
                <Table stickyHeader>
                    <TableHeader columns={columns} />
                    <TableBody>
                        {filteredMaterials
                            .slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                            .map( material => (
                                <TableRow className='table-row' sx={{ cursor: "pointer", "&:hover": { background: `${palette.rowHover} !important` } }} onClick={() => navigate( `/faculty/material/${material.study_material_id}` )} key={material.study_material_id}>
                                    <TableCell sx={{ color: table.color, padding: columns[0].padding || "5px 20px", alignItems: "center", gap: "10px" }} align='left'> <Box display="flex" gap="10px" alignItems="center">
                                        {Icons.default.Material} {material.study_material_name}
                                    </Box> </TableCell>
                                    <TableCell sx={{ color: table.color, padding: columns[1].padding || "5px 20px", textTransform: "capitalize" }} align='left'>{material.subject_name?.toLowerCase()} - {material.subject_code}</TableCell>
                                    <TableCell sx={{ color: table.color, padding: columns[2].padding || "5px 20px", }} align='left'>
                                        <Box display="flex" gap="5px" alignItems="center">
                                            <Box display="flex" alignItems="center" fontSize="18px" component="span">{Icons.default.Calendar}</Box>
                                            <Typography component="span" fontSize="inherit">{formatDate( material.study_material_published_date )}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ color: table.color, padding: columns[2].padding || "5px 20px", }} align='left'>
                                        <Box display="flex" gap="5px" alignItems="center">
                                            <Box display="flex" alignItems="center" fontSize="18px" component="span">{Icons.default.Calendar}</Box>
                                            <Typography component="span" fontSize="inherit">{formatDate( material.last_updated || material.study_material_published_date )}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ color: table.color, padding: columns[3].padding || "5px 20px", }} align='center'> <CustomChip value={material.download_count} startIcon={Icons.default.DownloadIcon} /> </TableCell>
                                    <TableCell sx={{ color: table.color, padding: columns[3].padding || "5px 20px", }} align='center'><CustomChip value={material.docs_count} startIcon={Icons.default.File} /> </TableCell>
                                </TableRow>
                            ) )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                sx={{ background: palette.contentBg, position: "sticky", bottom: "0", flexShrink: 0 }}
                rowsPerPageOptions={[50, 100, 150, 200]}
                component="div"
                count={filteredMaterials.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    )
}

export default FacultyMaterialsList
